import { render, staticRenderFns } from "./feature-card.vue?vue&type=template&id=1fbcdad2&scoped=true"
import script from "./feature-card.vue?vue&type=script&lang=js"
export * from "./feature-card.vue?vue&type=script&lang=js"
import style0 from "./feature-card.vue?vue&type=style&index=0&id=1fbcdad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbcdad2",
  null
  
)

export default component.exports